import { fetchRfiService as fetchWithToken } from '../utils/fetchRfiService';
import { getApiBaseUrl } from '../config';
import { headers, HttpMethod } from '../constants';
import { GetWorkflowResponseDefinition, UpdateWorkflowRequestDefinition } from '../types';
import { CreateSDKConfig } from './types';

const WorkflowApi = ({ projectId }: CreateSDKConfig) => {
  const baseUrl = `${getApiBaseUrl(projectId)}/workflow`;
  return {
    get(): Promise<GetWorkflowResponseDefinition> {
      const url = `${baseUrl}`;
      return fetchWithToken<GetWorkflowResponseDefinition>(url);
    },
    update(body: UpdateWorkflowRequestDefinition): Promise<GetWorkflowResponseDefinition> {
      const url = `${baseUrl}`;
      return fetchWithToken<GetWorkflowResponseDefinition>(url, {
        method: HttpMethod.Patch,
        body: JSON.stringify(body),
        headers,
      });
    },
  };
};

export default WorkflowApi;
